import React from 'react'
import dropdownIcon from '../assets/images/dropdown.png'
const Footer = () => {
  return (
    <footer className='footer'>
        <div className="footer-upper">
            <div className="footer-upper__left">
                <p>Занес: Овсяникова К.Ю</p>
                <div className="footer-dropzone">
                    <img src={dropdownIcon} alt="Dropdown Icon" />
                </div>
            </div>
            <div className="footer-upper__middle">
                <ol>
                    <li className="footer-list__item">Карта Гурова М.С Райффайзен</li>
                    <li className="footer-list__item">Карта Пинчук А.А Сбербанк</li>
                    <li className="footer-list__item">Карта Модернова (Сивцова) Альфа Банк, 4584 4329 6201 2051 (срок действия 12/28)</li>
                </ol>
            </div>
            <div className="footer-upper__right">
                <div>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
        <div className="footer-lower">
            <div className="footer-lower__texts">
                <p className='footer-lower__text'>Драгунов М.В..</p>
                <p className='footer-lower__text'>Версия: 10,0,16,9</p>
                <p className='footer-lower__text'>0,06+0,46+0,05 сек.</p>
            </div>
            <div className="footer-lower__deviders">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </footer>
  )
}

export default Footer